/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Retry Payment Button
 */
// todo

import { Button, ButtonProps } from 'antd';
import useRetryPayment from 'hooks/admin/mutate/useRetryPayment';

/**
 * Retry Payment
 *
 */
const RetryPayment: React.FC<{ externalId?: string } & ButtonProps> = ({ externalId, ...props }) => {
	const { mutate, isPending } = useRetryPayment();

	if (externalId) {
		return (
			<Button
				{...props}
				type='primary'
				onClick={() => {
					mutate({ invoiceId: externalId });
				}}
				loading={isPending}
			>
				{'Retry Payment'}
			</Button>
		);
	}
};

export default RetryPayment;
